import { baseApi } from "./baseAPI"
import {StatisticsModel} from "../dtos/statistics/statisticsModel";
import {DateRange} from "../../helpers/Types";
import {formatToYMD} from "../../helpers/dateHelper";
import { PromotionCriteria, promotionCriteriaToQuery } from "../dtos/promotions/promotionCriteria";
import { handleUrl } from "../../helpers/utils";

export const statisticsAPI = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getStatistics: build.query<StatisticsModel, PromotionCriteria | undefined>({
            query: (criteria) => {

                return {
                    url: handleUrl("Statistics", promotionCriteriaToQuery(criteria)),
                    method: 'GET'
                }
            },
            // transformErrorResponse: (response) => response.data
        })
    }),
    overrideExisting: false,
})

export const { useGetStatisticsQuery } = statisticsAPI
